import {equipmentOidTypes} from '@/components/mixins/ConversionMixin'

export default class VelhoPortalModel {
    // Private properties
    /** @type {string} */
    _external_system_id = equipmentOidTypes.EXTERNAL_PORTALS

    constructor(
        type = null, additionalType = null, condition = null, foundation = null, structure = null, code = '', length = null, lowerEdgeHeight = null, pilarHeightLevel = null,
        area = null, position = { x: null, y: null }, roadNum = null, roadSec = null, distance = null, equipmentDamages = [], locationDeviation = null,
        locationSpecification = { lane: [], side: null, tracks: null, central_area: null }, externalSystemId = ''
    ) {
        /** @type {number | null} */
        this.type = type

        /** @type {number | null} */
        this.additional_type = additionalType

        /** @type {number | null} */
        this.condition = condition

        /** @type {number | null} */
        this.foundation = foundation

        /** @type {number | null} */
        this.structure = structure

        /** @type {string} */
        this.code = code

        /** @type {number | null} */
        this.length = length

        /** @type {number | null} */
        this.lower_edge_height = lowerEdgeHeight

        /** @type {number | null} */
        this.pilar_height_level = pilarHeightLevel

        /** @type {number | null} */
        this.area = area

        /** @type {{ x: number, y: number }} */
        this.position = position

        /** @type {number | null} */
        this.road_num = roadNum

        /** @type {number | null} */
        this.road_sec = roadSec

        /** @type {number | null} */
        this.distance = distance

        /** @type {Array} */
        this.equipment_damages = equipmentDamages

        /** @type {number | null} */
        this.location_deviation = locationDeviation

        /** @type {{ lane: number[], side: number | null, tracks: number | null, central_area: number | null }} */
        this.location_specification = locationSpecification

        if(externalSystemId) {
            this._external_system_id = externalSystemId
        }
    }

    /**
    * Gets the unique identifier.
    * @returns {string}
    */
    get external_system_id() {
        return this._external_system_id
    }

    /**
    * Get the instance json object.
    * @returns {object}
    */
    toJSON() {
        return JSON.parse(JSON.stringify({
            external_system_id: this._external_system_id,
            type: this.type,
            additional_type: this.additional_type,
            condition: this.condition,
            foundation: this.foundation,
            structure: this.structure,
            code: this.code,
            length: this.length,
            lower_edge_height: this.lower_edge_height,
            pilar_height_level: this.pilar_height_level,
            area: this.area,
            position: this.position,
            road_num: this.road_num,
            road_sec: this.road_sec,
            distance: this.distance,
            equipment_damages: this.equipment_damages,
            location_deviation: this.location_deviation,
            location_specification: {
                ...this.location_specification,
                tracks: this.location_specification.tracks !== null ? [this.location_specification.tracks] : []
            }
        }))
    }

    /**
    * Create default Velho culvert instance with position data.
    * @param {{ x: number, y: number }} position - coordinates.
    * @param {number | null} roadNum - Road number.
    * @param {number | null} roadSec - road section.
    * @param {number | null} distance - distance (road geometry).
    * @returns {VelhoPortalModel} A new Velho culvert instance.
    */
    static instanceWithPosition(position, roadNum, roadSec, distance) {
        const instance = new VelhoPortalModel()
        instance.position = position
        instance.road_num = roadNum
        instance.road_sec = roadSec
        instance.distance = distance
        return instance
    }
}
